<template>
  <div class="Home">
    <a-row type="flex">
      <!-- breadcrumb -->
      <a-col :span="24" />
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
